module.exports = __webpack_public_path__ + "7c125559fc1bb5ef91221c546f5d1cd9.svg";